export default __webpack_public_path__ + "static/media/person.db8bbc83.png";